import { useModal } from '@stores';

const SecondaryModal = () => {
  const { secondaryModal } = useModal();
  const ModalContent = secondaryModal?.content;
  const secondaryModalProps = secondaryModal?.props;

  return !!ModalContent ? <ModalContent {...secondaryModalProps} /> : null;
};

export default SecondaryModal;
